import { render, staticRenderFns } from "./ErrorMessages.vue?vue&type=template&id=4a6bc44b&scoped=true&"
import script from "./ErrorMessages.vue?vue&type=script&lang=js&"
export * from "./ErrorMessages.vue?vue&type=script&lang=js&"
import style0 from "./ErrorMessages.vue?vue&type=style&index=0&id=4a6bc44b&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4a6bc44b",
  null
  
)

export default component.exports